import React from 'react';
import { Link } from 'react-router-dom';
import MainWebsiteNavbar from '../Components/MainWebsiteNavbar';
import '../assets/css/auth-theme.css';

const TextLogo = 'https://www.hvambit.me/assets/logo.png';

const GuestLayout = (props) => {
  const { children } = props;

  return (
    <>
      <MainWebsiteNavbar />
      <div className='auth-container'>
        <div className='hero-bg-glow'></div>

        {/* Navigation / Logo Area - Absolute positioned in new CSS */}
        <div className='auth-nav'>
          {/* If MainWebsiteNavbar handles nav, we might not need this explicitly here, 
                 but keeping logo link wrapper for consistent structure if desired.
                 However, the original GuestLayout had a explicit logo callout. 
             */}
        </div>

        <div className='container' style={{ position: 'relative', zIndex: 2 }}>
          <div className='row align-items-center justify-content-center'>
            {/* Visual Side (Left on Desktop) */}
            <div className='col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center'>
              <div className='text-center mb-5'>
                <Link to='/'>
                  <img src={TextLogo} width='180px' alt='logo' />
                </Link>
              </div>

              <div className='core-orb mb-4'>
                <i className='fas fa-shield-alt'></i>
              </div>

              <div className='text-center px-5'>
                <h2 className='font-weight-bold mb-3' style={{ color: 'var(--text-primary)' }}>
                  {props.Title}
                </h2>
                <p className='text-muted'>{props.Subtitle}</p>
              </div>
            </div>

            {/* Form Side (Right on Desktop) */}
            <div className='col-lg-5 col-md-8 col-sm-10'>
              <div className='glass-card'>
                <div className='text-center mb-4'>
                  <h3 className='font-weight-bold mb-1'>{props.FormTitle}</h3>
                  <p className='text-secondary mb-0'>{props.FormSubTitle}</p>
                </div>
                {children}
              </div>
              <div className='text-center mt-3 d-lg-none'>
                <Link to='/'>
                  <span className='text-muted text-sm'>Back to Home</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestLayout;
